import { createSlice } from "@reduxjs/toolkit";
const CryptoJS = require("crypto-js");
require("dotenv").config();

const initialState = {
  data: {},
  activeOrganization: {},
};

export const authSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      const encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(action.payload),
        process.env.REACT_APP_LOCAL_STORAGE_SECRET
      ).toString();
      state.data = encrypted;
    },
    loginFailed: (state) => {
      state.data = {};
    },
    activeOrganization: (state, action) => {
      state.activeOrganization = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { loginSuccess, loginFailed, activeOrganization } =
  authSlice.actions;
export default authSlice.reducer;
